(() => {
  const init = () => {
    const form = document.querySelector('.art-submit__form');
    if (!(form instanceof HTMLFormElement) || form.dataset.ellivieArtBackend === 'true') return;
    form.dataset.ellivieArtBackend = 'true';

    // Stop using FormSubmit. The Ellivie backend accepts the existing multipart
    // form and reads every file from the original multiple file input.
    form.action = 'https://minecraft.tail760c90.ts.net/api/art-submission';
    form.method = 'POST';
    form.enctype = 'multipart/form-data';

    const fileInput = form.querySelector('.art-submit__file[type="file"]');
    if (fileInput) {
      fileInput.name = 'attachment';
      delete fileInput.dataset.attachmentsPrepared;
    }
    form.querySelectorAll('[data-art-attachment-clone]').forEach((node) => node.remove());

    let returnInput = form.querySelector('input[name="returnTo"]');
    if (!(returnInput instanceof HTMLInputElement)) {
      returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'returnTo';
      form.appendChild(returnInput);
    }
    returnInput.value = window.location.href;

    const params = new URLSearchParams(window.location.search);
    const result = params.get('art_submission');
    const section = form.closest('.art-submit');

    if (result === 'success' && section) {
      section.classList.add('art-submit--submitted');
    } else if (result === 'error') {
      const message = params.get('art_submission_error') || 'Bidraget kunde inte skickas just nu. Försök igen.';
      let error = form.querySelector('[data-art-backend-error]');
      if (!error) {
        error = document.createElement('div');
        error.dataset.artBackendError = '';
        error.style.cssText = 'padding:12px 14px;border-radius:10px;background:#fff1ef;color:#8b2d24;font-size:13px;font-weight:700';
        form.prepend(error);
      }
      error.textContent = message;
    }

    form.addEventListener('submit', () => {
      returnInput.value = window.location.href;
      if (fileInput) fileInput.name = 'attachment';
      form.querySelectorAll('[data-art-attachment-clone]').forEach((node) => node.remove());
    }, true);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
